import store from "./store";
import App from "./common/firebase.app";
import RepositoryFactory from "./services/RepositoryFactory";

const UserRepository = RepositoryFactory.get("users");

const setCurrentUserRoles = email => {
  return new Promise((resolve, reject) => {
    if (!store.getters.userRoles) {
      UserRepository.fetch().then(users => {
        store.dispatch("updateSchoolUsers", users);
        const found = users.find(user => {
          return user.email === email;
        });
        if (!found) {
          reject(new Error("User ของคุณไม่ถูกต้อง"));
        }
        const { role } = found;
        store.dispatch("setUserRoles", role);
        resolve(role);
      });
    } else {
      resolve(store.getters.userRoles);
    }
  });
};

export default async (to, from, next) => {
  let auth = await App.getCurrentUser();

  if (auth) {
    await setCurrentUserRoles(auth.email);
    next();
  } else {
    next({
      path: "/login"
    });
  }
};
